import { useEffect, useState, useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AbilityContext } from '@src/utility/context/Can'
import Spinner from '@src/@core/components/spinner/Fallback-spinner'
import useJwt from '@src/auth/jwt/useJwt'
import { handleLogout } from '@store/authentication'
import { adminAbility, clientAbility } from '@src/configs/acl/mlpro/utilAbility'

const AuthInit = ({ children }) => {
  const [ready, setReady] = useState(false)
  const dispatch = useDispatch()
  const ability = useContext(AbilityContext)
  const userData = useSelector(state => state.auth.userData)

  useEffect(() => {
    const init = async () => {
      // Sin sesión previa → nada que hacer
      if (!userData?.id) {
        setReady(true)
        return
      }

      // Token ya en memoria (navegación dentro de la misma sesión SPA)
      if (useJwt.getToken()) {
        if (!ability.can('read', 'Auth')) {
          ability.update(userData.role === 'admin' ? adminAbility() : clientAbility())
        }
        setReady(true)
        return
      }

      // Sesión previa existe pero sin token en memoria (F5 / reabrir browser)
      try {
        const r = await useJwt.refreshToken()
        const newToken = r?.data?.access_token || r?.data?.accessToken
        if (newToken) {
          useJwt.setToken(newToken)
          ability.update(userData.role === 'admin' ? adminAbility() : clientAbility())
        } else {
          dispatch(handleLogout())
        }
      } catch {
        dispatch(handleLogout())
      }

      setReady(true)
    }

    init()
  }, [])

  if (!ready) return <Spinner />
  return children
}

export default AuthInit
